export enum LOCATIONS_FILTERS {
  LOCATION_ID = "filter[location_id]",
  ORGANIZATION_ID = "filter[organization_id]",
}
